import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { getForumBackend } from "../../services/moodle/forum";

export const useAttachmentPolicy = () => {
  const auth = useAuth();
  const query = useQuery({
    queryKey: ["forum", "attachment-policy", auth.user?.id],
    queryFn: () => getForumBackend({ token: auth.user.token }),
    enabled: Boolean(auth.user?.token),
    staleTime: 60_000,
  });
  return { policy: query.data?.attachment_policy, error: query.error };
};
